import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconEnvelopeOpenText } from '#src/atoms/icons/system/iconEnvelopeOpenText.ts';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Bold } from '#src/atoms/typography/Bold/index.tsx';
import { BodyM, HeadlineM, HeadlineS } from '#src/atoms/typography/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import { useScreenSize } from '#src/hooks/device/useScreenSize.ts';
import { glossary } from '#src/lib/glossary.ts';

const messages = defineMessages({
  title: {
    defaultMessage: 'Change email',
  },
  subtitle: {
    defaultMessage: 'Verify your new email adress',
  },
  description: {
    defaultMessage:
      'We’ll need to verify your new email adress <b>{email}</b> in order to change it',
  },
});

const Content = styled(Vertical).attrs({ gap: 2 })`
  text-align: center;
  padding: var(--triple-unit);
`;

type Props = {
  email: string;
  onClose: () => void;
};

export const UpdateEmailDialog = ({ email, onClose }: Props) => {
  const { up: isTablet } = useScreenSize('tablet');

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open
      onClose={onClose}
      fullScreen={!isTablet}
      title={
        <HeadlineM as="h2" className="text-center">
          <FormattedMessage {...messages.title} />
        </HeadlineM>
      }
    >
      <Content>
        <FontAwesomeIcon
          icon={iconEnvelopeOpenText}
          size="5x"
          color="var(--c-white)"
        />
        <HeadlineS as="h5">
          <FormattedMessage {...messages.subtitle} />
        </HeadlineS>
        <BodyM color="var(--c-nd-600)">
          <FormattedMessage
            {...messages.description}
            values={{
              b: Bold,
              email,
            }}
          />
        </BodyM>
        <Button onClick={onClose} color="quaternary" size="medium" fullWidth>
          <FormattedMessage {...glossary.ok} />
        </Button>
      </Content>
    </Dialog>
  );
};
